import "./DataTable.css";

interface Column {
  key: string;
  label: string;
  render?: (row: any) => React.ReactNode;
}

interface DataTableProps {
  columns: Column[];
  data: any[];
  isLoading?: boolean;
  onEdit?: (row: any) => void;
  onDelete?: (id: string) => void;
  customActions?: (row: any) => React.ReactNode; // NEW: Custom actions per row
  emptyMessage?: string;
  editLabel?: string;
  showEditButton?: boolean;
  showActions?: boolean;
}

const DataTable = ({
  columns,
  data,
  isLoading = false,
  onEdit,
  onDelete,
  customActions,
  emptyMessage = "No data available",
  editLabel = "Edit",
  showEditButton = true,
  showActions = true,
}: DataTableProps) => {
  if (isLoading) {
    return (
      <div className="data-table-wrapper">
        <div className="table-loading">
          <div className="table-spinner"></div>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  if (data.length === 0) {
    return (
      <div className="data-table-wrapper">
        <div className="table-empty">
          <div className="table-empty-icon">📭</div>
          <p>{emptyMessage}</p>
        </div>
      </div>
    );
  }

  const showActionsColumn =
    showActions && (onEdit || onDelete || customActions);

  return (
    <div className="data-table-wrapper">
      <table className="data-table">
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.key}>{col.label}</th>
            ))}
            {showActionsColumn && <th>Actions</th>}
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={row._id || row.id || index}>
              {columns.map((col) => (
                <td key={col.key}>
                  {col.render ? col.render(row) : row[col.key]}
                </td>
              ))}
              {showActionsColumn && (
                <td>
                  <div className="table-actions">
                    {/* Standard actions (Edit/Delete) */}
                    {onEdit && showEditButton && (
                      <button
                        className="btn-icon edit"
                        onClick={() => onEdit(row)}
                        title={editLabel}
                      >
                        ✏️
                      </button>
                    )}
                    {onDelete && (
                      <button
                        className="btn-icon delete"
                        onClick={() => onDelete(row._id || row.id)}
                        title="Delete"
                      >
                        🗑️
                      </button>
                    )}

                    {/* Custom actions (if provided) */}
                    {customActions && customActions(row)}
                  </div>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DataTable;
